<p-dialog [style]="{minWidth: '450px', minHeight: '300px'}" [closeOnEscape]="false" [closable]="false" header="{{dialogTitle}}" [(visible)]="displayDialog" [responsive]="true" showEffect="fade" [modal]="true" appendTo="body">

    <form class="validated-form" [formGroup]="form">
      <div class="ui-grid ui-grid-responsive ui-fluid">

        <div class="field grid form-group">
          <label class="col-fixed">Category</label>
            <div class="col-fixed inputfield">
              <input class="form-control" name="name" pInputText placeholder="category" formControlName="name" />
              <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert-danger">
                <p *ngIf="name.errors.name_already_exists">Name already exists</p>
                <p *ngIf="name.errors.required">Category is required</p>
                <p *ngIf="name.errors.maxlength">Category is too long</p>
                <p *ngIf="name.errors.categoryNameTaken">A Category with the name '{{name.value}}' already exists</p>
              </div>
            </div>
        </div>

        <div class="field grid form-group">
          <label class="col-fixed">Default Expiry</label>
          <div class="col-fixed">
              <input class="form-control" formControlName="duration" type="number" min="0" max="999" />
              <div class="alert-danger" *ngIf="duration.invalid && (duration.dirty || duration.touched)">
                <p *ngIf="duration.errors.max">must be between 0-999</p>
              </div>
            </div>
            <div class="col-fixed dropdown-field">
              <p-dropdown hideDropdownOnScroll formControlName="selectedExpiryType" [options]="expiryTypes" appendTo="body" optionLabel="label" class="dropdown"></p-dropdown>
            </div>
        </div>

      </div>
    </form>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <button type="button" [disabled]="form.invalid || form.pristine" pButton icon="fa-fw fa fa-check" (click)="save()" label="Save"></button>
      <button type="button" pButton icon="fa-fw fa fa-close" (click)="cancel()" label="Cancel"></button>
    </div>
  </p-footer>
</p-dialog>
